import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'

export const $liveEventsTranslations = combine(i18n.$t, ({ t }) => ({
  liveCardStatusLabel: t('live'),
}))
